import React, { useEffect, useState } from "react";

import DestinoFila from "./DestinoFila";
import Categorias from "./Categorias.js";
import SeccionBuscador from "./SeccionBuscador";
import BancosSlider from "./BancosSlider.js";
import { productosAPI, toolsAPI } from "../../utils/funcionesAPI";
import {
  stockEnDemanda,
  manejadorDeRespuesta,
  deJSAFechaAmericana,
  formatearFecha,
  armarFilasDelSlider,
} from "../../utils/Tools";
import { ToastContainer } from "react-toastify";
import Loader from "../Global/Loader.js";
import Modal from "../Global/Modal.js";
import ModalApp from "../Global/ModalApp";
// import ModalParaBusqueda from "./ModalParaBusqueda.js";
// import ReactTooltip from 'react-tooltip'

const Home = (props) => {
  const {
    onSelectChange,
    onSelectOrigenChange,
    onSelectDestinoChange,
    onSelectPeriodoChange,
    onSelectEmbarqueBusquedaChange,
    onSelectTipoBusquedaChange,
    onAdultosChange,
    onMenoresChange,
    onEdadChange,
    busqueda,
    onUpdateState,
  } = props;
  const [productos, setProductos] = useState([]);
  const [grupoSeleccionado, setGrupoSeleccionado] = useState({});
  //const [mostrarModalBusqueda, setMostrarModalBusqueda] = useState(false);
  //const [peticionServicioProducto, setPeticionServicioProducto] = useState(6);
  const [loaded, setLoaded] = useState(false);
  const [fancy, setFancy] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    traerFancyBanner();
    stockEnDemanda(9);
    handleAdultosChange(2);
    window.scrollTo(0, 0);
    if (window.screen.width < 768) setIsMobile(true);
  }, []);

  useEffect(() => {
    traerProductosPorOrigen();
  }, []);

  const handleCombosBusquedaChange = (propiedad, valor) => {
    onSelectChange(propiedad, valor);
  };

  const handleCombosOrigenBusquedaChange = (origen) => {
    onSelectOrigenChange(origen);
  };

  const handleCombosDestinoBusquedaChange = (dest) => {
    onSelectDestinoChange(dest);
  };

  const handleComboPeriodoBusquedaChange = (
    fecha,
    destino,
    codigoProvinciaOrigen,
    idPuntoDeEmbarque
  ) => {
    onSelectPeriodoChange(
      fecha,
      destino,
      codigoProvinciaOrigen,
      idPuntoDeEmbarque
    );
  };

  const handleComboEmbarqueBusquedaChange = (embarque) => {
    onSelectEmbarqueBusquedaChange(embarque);
  };

  const handleRadioCambiarTipoBusquedaChange = (value) => {
    onSelectTipoBusquedaChange(value);
  };

  const handleAdultosChange = (cantidad) => {
    onAdultosChange(cantidad);
  };

  const handleMenoresChange = (cantidad) => {
    onMenoresChange(cantidad);
  };

  const handleEdadChange = (clave, valor) => {
    onEdadChange(clave, valor);
  };

  const handleGrupoClick = (grupo) => {
    //console.log(idGrupo);
    //setPeticionServicioProducto(9);
    //setMostrarModalBusqueda(true);
    setGrupoSeleccionado(grupo);
  };

  const isIphone = () => {
    //let navegador = navigator.userAgent;
    if (
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i)
    ) {
      return true;
    }
    return false;
  };

  const traerProductosPorOrigen = () => {
    //var _this = this;
    let data = JSON.stringify({
      peticion: "traerProductosPorOrigen",
      origen: "CENT",
      idGrupo: grupoSeleccionado.idGrupo,
      canal: "web",
    });
    setLoaded(false);
    //this.setState({ loaded: false });
    productosAPI(data).then((respuesta) => {
      setLoaded(true);
      //this.setState({ loaded: true });
      if (manejadorDeRespuesta(props, respuesta)) {
        setProductos(respuesta.data);
      }
      //this.setState({ productos: respuesta.data });
    });
  };

  const traerFancyBanner = () => {
    //var _this = this;
    let data = JSON.stringify({
      accion: "traerFancyBanner",
      canal: "WEB",
      origen: busqueda.origen || "CENT",
    });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        const newFancy = {
          ...respuesta.data,
          ...(respuesta.data.fechaFinalizacion && {
            fechaFinalizacion: new Date(respuesta.data.fechaFinalizacion),
          }),
        };
        setFancy(newFancy);
        // this.setState({ fancy });
      }
    });
  };

  //render() {
  //const { productos, fancy } = this.state;
  const { productos1raFila, productos2daFila, productos3raFila } =
    armarFilasDelSlider(productos);
  const fechaParaGrupoComercial = formatearFecha(
    deJSAFechaAmericana(new Date())
  );

  return (
    <div>
      <SeccionBuscador
        busqueda={busqueda}
        origen={busqueda.origen}
        onSelectChange={handleCombosBusquedaChange}
        onSelectOrigenChange={handleCombosOrigenBusquedaChange}
        onSelectDestinoChange={handleCombosDestinoBusquedaChange}
        onSelectPeriodoChange={handleComboPeriodoBusquedaChange}
        onSelectEmbarqueBusquedaChange={handleComboEmbarqueBusquedaChange}
        onSelectTipoBusquedaChange={handleRadioCambiarTipoBusquedaChange}
        onAdultosChange={handleAdultosChange}
        onMenoresChange={handleMenoresChange}
        onEdadChange={handleEdadChange}
      />

      <Categorias
        onGrupoClick={handleGrupoClick}
        origen={busqueda.origen}
        fecha={fechaParaGrupoComercial}
      />

      <Loader
        loaded={loaded}
        mensaje="Buscando Paquetes, aguarde unos instantes..."
      />
      {loaded && (
        <div style={{ marginTop: "1rem" }}>
          {productos1raFila.length > 0 && (
            <DestinoFila
              titulo="Destacados"
              productos={productos1raFila}
              origen={busqueda.origen}
              destino={busqueda.destino}
              fecha={busqueda.fecha}
            />
          )}
          {/*---SI HAY MAS DE 8 PRODUCTOS MUESTRO LA 2da FILA---*/}
          {productos2daFila.length > 3 && (
            <DestinoFila
              titulo="Otros Destinos"
              productos={productos2daFila}
              origen={busqueda.origen}
              destino={busqueda.destino}
              fecha={busqueda.fecha}
            />
          )}
          {/*---SI HAY MAS DE 12 PRODUCTOS MUESTRO LA 2da FILA---*/}
          {productos3raFila.length > 3 && (
            <DestinoFila
              titulo="Además"
              productos={productos3raFila}
              origen={busqueda.origen}
              destino={busqueda.destino}
              fecha={busqueda.fecha}
            />
          )}
        </div>
      )}

      <BancosSlider />

      <ToastContainer />
      {/*---MOSTRAR MODAL HASTA FECHA FINALIZACION ---*/}
      {!isMobile &&
        fancy.estado &&
        new Date().getTime() <= fancy.fechaFinalizacion.getTime() && (
          <Modal fancy={fancy} />
        )}
      {isMobile && <ModalApp />}
      {/*---MOSTRAR MODAL PARA GRUPOS COMERCIALES (POR AHORA OCULTO) ---
      {mostrarModalBusqueda && (
        <ModalParaBusqueda
          busqueda={busqueda}
          grupo={grupoSeleccionado}
          onUpdateState={onUpdateState}
          setMostrarModalBusqueda={setMostrarModalBusqueda}
          onSelectChange={handleCombosBusquedaChange}
          onSelectOrigenChange={handleCombosOrigenBusquedaChange}
          onSelectDestinoChange={handleCombosDestinoBusquedaChange}
          onSelectPeriodoChange={handleComboPeriodoBusquedaChange}
          onSelectEmbarqueBusquedaChange={handleComboEmbarqueBusquedaChange}
          onAdultosChange={handleAdultosChange}
          onMenoresChange={handleMenoresChange}
          onEdadChange={handleEdadChange}
        />
      )}
        */}
    </div>
  );
  //}
};

export default Home;
/*

  /*traerProductosConValijaYa() {
        var _this = this;

        let data = JSON.stringify({peticion: 10, origen: this.props.busqueda.origen});

        productosAPI(data)
                .then(productos => {
                  if (!productos) {
                    alert('Ha surgido un error en traer los productos promocionados');
                    return;
                  }
                    _this.setState({productosPromocionados: productos});
                });
    }
*/

/*FC: componente para mostrar en el toast

new Date().getDate() === this.state.fechaFinalizacionModal.getDate() &&
new Date().getHours() <= this.state.fechaFinalizacionModal.getHours()
class NewMessageNotification extends React.Component {

  displayMessage = () => {
    //remove all notifications
    toast.dismiss();

    //navigate to the link. I'll use location hash but it can be done with any router solution
    window.location.hash = "";
  }

  render(){
    return (
      <div style={{color: '#767676'}}>
        volver al sitio web tradicional haciendo click <a href="http://pedrazavyt.com.ar/indexTradicional.php">AQUI</a>
      </div>
    );
  }
}*/



// WEBPACK FOOTER //
// ./src/components/Home/index.js